var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlarmIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 14,
    fill: "#FD822A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_256_12697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5498 36.8772L39.2854 36.6439C38.5352 35.9755 37.8785 35.2089 37.3332 34.365C36.7376 33.2003 36.3806 31.9284 36.2832 30.6239V26.7817C36.2883 24.7327 35.5451 22.7524 34.1931 21.2128C32.8411 19.6732 30.9734 18.6802 28.941 18.4206V17.4172C28.941 17.1419 28.8316 16.8778 28.6368 16.683C28.4421 16.4883 28.178 16.3789 27.9026 16.3789C27.6272 16.3789 27.3631 16.4883 27.1684 16.683C26.9737 16.8778 26.8643 17.1419 26.8643 17.4172V18.4361C24.85 18.7145 23.0049 19.7134 21.6707 21.2479C20.3365 22.7823 19.6035 24.7483 19.6076 26.7817V30.6239C19.5102 31.9284 19.1532 33.2003 18.5576 34.365C18.0216 35.2068 17.3756 35.9733 16.6365 36.6439L16.3721 36.8772V39.0706H39.5498V36.8772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.916 39.8906C25.9842 40.3836 26.2285 40.8353 26.6038 41.1623C26.9791 41.4892 27.46 41.6693 27.9577 41.6693C28.4554 41.6693 28.9363 41.4892 29.3116 41.1623C29.6868 40.8353 29.9311 40.3836 29.9993 39.8906H25.916Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_256_12697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(14 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmIcon);
export default __webpack_public_path__ + "static/media/alarmIcon.c81f6f546137ee6ad2471d69997f68ee.svg";
export { ForwardRef as ReactComponent };